import XImage from "../../assets/images/svgs/cancel-svgrepo-com (2).png";
import styles from "./modal.module.css";

const Modal = ({ closeModalHandler, children }) => {
  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <div className={styles.closeWrapper}>
          <img
            src={XImage}
            alt="close"
            className={styles.ximage}
            onClick={closeModalHandler}
          />
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;
